import '@/styles/templates/collection.scss'
console.log('HERE ONLY COLLECTION!')
